module.exports = __webpack_public_path__ + "media/src/img/fond-1958e35b44b033976baa6f5549bcd0f9.svg";